import n, { useState as s } from "react";
import { useTheme as M, ButtonGroup as C, Button as E, Menu as k, MenuItem as y } from "@mui/material";
import { E as v } from "./chunk.B1uNhpja.js";
import { u as I } from "./chunk.TLGGOfPB.js";
const R = ({
  mainButton: a,
  additionalActions: x,
  variant: l = "contained",
  ...e
}) => {
  const c = M(), d = I().themeName === "Unstable Single UI" ? 2 : 1, [m, u] = s(null), b = !!m, [i, o] = s(!1), [B, r] = s(!1), h = `${e.id ?? e["aria-label"]}-menu-button`, p = `${e.id ?? e["aria-label"]}-menu`;
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
    C,
    {
      id: e.id,
      variant: l,
      "aria-label": e["aria-label"],
      disableRipple: !0,
      disableElevation: !0,
      disabled: e.disabled,
      sx: {
        "& .MuiButtonGroup-firstButton": {
          ...B && {
            borderRightColor: "transparent"
          },
          ...i && {
            borderRightColor: "transparent"
          }
        }
      }
    },
    /* @__PURE__ */ n.createElement(
      E,
      {
        onClick: a.onClick,
        type: a.type,
        onMouseOver: () => o(!0),
        onMouseLeave: () => o(!1),
        onFocusVisible: () => {
          r(!0);
        },
        onBlur: () => r(!1),
        sx: {
          ...l === "outlined" && i && {
            border: `${d}px solid ${c.palette.primary.dark}`
          }
        }
      },
      a.buttonText
    ),
    /* @__PURE__ */ n.createElement(
      E,
      {
        id: h,
        "aria-controls": p,
        "aria-expanded": b,
        "aria-label": `${e["aria-label"]} Menu Button`,
        "aria-haspopup": "menu",
        onClick: (t) => u(t.currentTarget),
        onMouseOver: () => o(!0),
        onMouseLeave: () => o(!1),
        onFocusVisible: () => r(!0),
        onBlur: () => r(!1),
        sx: {
          ...l === "outlined" && i && {
            border: `${d}px solid ${c.palette.primary.dark}`
          }
        }
      },
      /* @__PURE__ */ n.createElement(v, null)
    )
  ), /* @__PURE__ */ n.createElement(
    k,
    {
      id: p,
      open: b,
      anchorEl: m,
      onClose: () => u(null),
      anchorOrigin: { horizontal: "right", vertical: "bottom" },
      transformOrigin: { horizontal: "right", vertical: "top" },
      MenuListProps: {
        "aria-labelledby": h
      }
    },
    x.map((t) => /* @__PURE__ */ n.createElement(
      y,
      {
        onClick: (g) => {
          var f;
          u(null), (f = t.onClick) == null || f.call(t, g);
        },
        component: "button",
        type: t.type,
        key: t.buttonText
      },
      t.buttonText
    ))
  ));
};
export {
  R as S
};
